// Exhibitions slider, which is also just image slider.
const $ = jQuery;

const initSlider = () => {
  const els = once('image-carousel', '.p-image-carousel');
  els.forEach((el) => {
    const $wrapper = $(el);
    const $slider = $wrapper.find('.pes-slider');
    const slideCount = $slider.children().length;

    // Ensure images have aspect ratio before initializing slider
    const $images = $slider.find('img');

    // Force aspect ratio on image containers based on their class
    $slider.find('.pes-slide-image').each(() => {
      const $container = $(this);

      // Determine aspect ratio from class
      let aspectRatio = '3 / 2'; // default
      if ($container.hasClass('height-images-image-style-4-3')) {
        aspectRatio = '4 / 3';
      }

      // Ensure aspect ratio is applied (important for lazy-loaded images)
      $container.css('aspect-ratio', aspectRatio);
    });

    // Wait for images to be ready (either loaded or lazy-load initialized)
    const initializeSlider = () => {
      // Get current slide number and display under slider on mobile
      $slider.on(
        'init reInit afterChange',
        function handleResize(event, slick, currentSlide) {
          const currentSlideNum = (currentSlide || 0) + 1;
          $wrapper
            .find('.om-slider-count')
            .text(`${currentSlideNum} of ${slick.slideCount}`);
        },
      );

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '80px',
        dots: true,
        autoplay: true,
        infinite: slideCount > 3,
        accessibility: true,
        pauseOnHover: true,
        autoplaySpeed: 3000,
        prevArrow: $wrapper.find('.om-slider-arrow-prev'),
        nextArrow: $wrapper.find('.om-slider-arrow-next'),
        appendDots: $wrapper.find('.om-slider-dots'),
        lazyLoad: 'progressive',
        responsive: [
          {
            breakpoint: 1480,
            settings: {
              slidesToShow: 3,
              centerPadding: '10px',
            },
          },
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 1,
              centerPadding: 'calc(50% - 270px)',
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              centerPadding: '10px',
            },
          },
        ],
      });

      // Refresh slider after lazy images load to ensure proper positioning
      $images.on('load lazyloaded', () => {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('setPosition');
        }
      });
    };

    // Initialize immediately on DOMContentReady instead of waiting for load
    initializeSlider();
  });
};

// Use DOMContentLoaded instead of window.load for faster initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSlider);
} else {
  // DOM already loaded
  initSlider();
}
